export const useActionRefreshProfile = () => {
  const { onPlay, complete, isRootPath } = useAbstractAction(
    'actionRefreshProfile',
    false,
    7000,
    [ActionRefreshData]
  );

  const profileLoadFromNetwork = useProfileLoadFromNetwork();

  onPlay(async () => {
    if (isRootPath.value) {
      await profileLoadFromNetwork.run();
      complete(true);
    } else {
      complete(false);
    }
  });
};
